/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Reddit Conversions API helpers (Pro)
 *
 * The base payload the Conversions API events carry: visitor UUID, click ID
 * and user data. The adapter falls back to a base without them when
 * pmw.getRedditS2SBaseData is absent, which is the case on a free build.
 * */

(function (pmw, undefined) {

	/**
	 * Get base Reddit S2S event data structure
	 * https://ads-api.reddit.com/docs/v3/capi-direct-integration
	 *
	 * @return {object}
	 */
	pmw.getRedditS2SBaseData = () => {
		const data = {
			event_at     : Date.now(), // Unix timestamp in milliseconds
			action_source: "WEBSITE",
			user         : {},
		};

		// Add user agent
		if (navigator.userAgent) {
			data.user.user_agent = navigator.userAgent;
		}

		// Add Reddit UUID if available
		const rdtUuid = pmw.getCookie("_rdt_uuid");
		if (rdtUuid) {
			data.user.uuid = rdtUuid;
		}

		// Add Reddit click ID if available (from rdtCid cookie)
		const rdtClickId = pmw.getCookie("rdtCid");
		if (rdtClickId) {
			data.click_id = rdtClickId;
		}

		// Add advanced matching data if enabled
		if (pmwDataLayer?.pixels?.reddit?.advanced_matching) {
			if (pmwDataLayer?.user?.email?.sha256) {
				data.user.email = pmwDataLayer.user.email.sha256;
			}

			if (pmwDataLayer?.user?.id?.sha256) {
				data.user.external_id = pmwDataLayer.user.id.sha256;
			}
		}

		return data;
	};

}(window.pmw = window.pmw || {}));
